import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    HomeIcon,
    HeartIcon,
    CalculatorIcon,
    UserIcon,
    NewspaperIcon,
} from '@heroicons/react/24/outline';
import {
    HomeIcon as HomeIconSolid,
    HeartIcon as HeartIconSolid,
    CalculatorIcon as CalculatorIconSolid,
    UserIcon as UserIconSolid,
    NewspaperIcon as NewspaperIconSolid,
} from '@heroicons/react/24/solid';
import { useAuth } from '../../contexts/AuthContext';
import styles from './BottomNav.module.scss';

interface NavItem {
    name: string;
    href: string;
    icon: React.ReactNode;
    activeIcon: React.ReactNode;
}

const BottomNav: React.FC = () => {
    const location = useLocation();
    const { user, isAuthenticated } = useAuth();

    const navItems: NavItem[] = [
        {
            name: 'Beranda',
            href: '/',
            icon: <HomeIcon className={styles.icon} />,
            activeIcon: <HomeIconSolid className={styles.icon} />,
        },
        {
            name: 'Program',
            href: '/programs',
            icon: <HeartIcon className={styles.icon} />,
            activeIcon: <HeartIconSolid className={styles.icon} />,
        },
        // {
        //     name: 'Zakat',
        //     href: '/zakat-calculator',
        //     icon: <CalculatorIcon className={styles.icon} />,
        //     activeIcon: <CalculatorIconSolid className={styles.icon} />,
        // },
        {
            name: 'Berita',
            href: '/news',
            icon: <NewspaperIcon className={styles.icon} />,
            activeIcon: <NewspaperIconSolid className={styles.icon} />,
        },
        {
            name: isAuthenticated ? 'Profil' : 'Masuk',
            href: isAuthenticated ? '/profile' : '/login',
            icon: <UserIcon className={styles.icon} />,
            activeIcon: <UserIconSolid className={styles.icon} />,
        },
    ];

    const isActive = (href: string) => {
        if (href === '/') return location.pathname === '/';
        return location.pathname.startsWith(href);
    };

    return (
        <nav className={styles.bottomNav} role="navigation" aria-label="Navigasi utama mobile">
            <div className={styles.navContainer}>
                {navItems.map((item) => {
                    const active = isActive(item.href);
                    return (
                        <Link
                            key={item.name}
                            to={item.href}
                            className={`${styles.navItem} ${active ? styles.active : ''}`}
                            aria-current={active ? 'page' : undefined}
                        >
                            <span className={styles.iconWrapper}>
                                {active ? item.activeIcon : item.icon}
                            </span>
                            <span className={styles.label}>{item.name}</span>
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
};

export default BottomNav;
